import request from '@/utils/request'

// 查询会议室类型
export function searchType(query) {
  return request({
    url: 'deliverType/search',
    method: 'post',
    data: query
  })
}
// 新增
export function addType(type_name) {
  return request({
    url: 'deliverType',
    method: 'post',
    data: { name: type_name }
  })
}
// 新增
export function editType(id, type_name) {
  return request({
    url: 'deliverType/edit/' + id,
    method: 'post',
    data: { name: type_name }
  })
}
